{
  "Language.SelectorLabel": "Change language",
  "Language.FollowMicrosoft365": "Use my Microsoft 365 language",
  "Language.SaveFailed": "Your language choice could not be saved. It applies in this browser until your next visit.",
  "Header.SignOut": "Sign out",
  "Workspace.Brand": "Edinshall supplier collaboration",
  "Workspace.Title": "Supplier Quality Workspace"
}
